export function formHide () {
    var wpcf7El = document.querySelector('.wpcf7')
    var thankYouEl = document.querySelector('.form-thank-you')

    if (wpcf7El && thankYouEl) {
        wpcf7El.addEventListener('wpcf7submit', e => {
            if (e.detail.status === 'mail_sent') {
                wpcf7El.parentNode.removeChild(wpcf7El)
                thankYouEl.classList.remove('hide')
            }
        }, false)
    }
}


// WEBPACK FOOTER //
// ./mtwp/Theme/Js/Cf7/index.js